import { Link } from "react-router-dom";

const utilityLinks = [
  { label: "Hijab Quiz", href: "/quiz" },
  { label: "Gift Cards", href: "/gift-cards" },
  { label: "New Arrivals", href: "/shop?sort=newest" },
  { label: "Best Sellers", href: "/shop?sort=best-sellers", isCta: true },
];

const UtilityBar = () => {
  return (
    <nav aria-label="Quick links" className="bg-foreground text-background text-[11px] md:text-xs z-40 md:hidden">
      <div className="container mx-auto px-3 md:px-4">
        <ul className="flex items-center justify-start gap-3 md:gap-5 h-9 overflow-x-auto scrollbar-hide list-none m-0 p-0">
          {utilityLinks.map((link, i) => (
            <li key={link.href} className="flex items-center gap-3 md:gap-5 flex-shrink-0">
              {i > 0 && (
                <span className="text-[#C4A882]" aria-hidden="true">·</span>
              )}
              <Link
                to={link.href}
                className={
                  link.isCta
                    ? "text-primary font-bold hover:underline underline-offset-2 whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded inline-flex items-center min-h-[36px] py-2 -my-2"
                    : "text-background/80 hover:text-background font-medium transition-colors whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded inline-flex items-center min-h-[36px] py-2 -my-2"
                }
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default UtilityBar;
